import { render } from "./GenderChart.vue?vue&type=template&id=1fa8ac6a"
import script from "./GenderChart.vue?vue&type=script&lang=js"
export * from "./GenderChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__